export const SNAPSHOTS_QUERY_MAX_DAYS = 100;

export const SNAPSHOTS_QUERY_STALE_TIME = 1000 * 60 * 2;
